import Modifier from 'ember-modifier';

export default class SpdsAutofocus extends Modifier {
  focused = false;

  // automatically focus passed element on intial render, then
  // skip on re-renders
  modify = (element, [autofocus = false]) => {
    // skip if autofocus is false
    this.focused = !autofocus;

    if (this.focused) return;

    element.focus();

    this.focused = true;
  };
}
